module.exports = __webpack_public_path__ + "img/huanbao4.104c87ce.png";